import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FileText, ShieldCheck, Scale, AlertCircle } from 'lucide-react';
import { Helmet } from 'react-helmet-async'; // Added for SEO
import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import Nav from "../Header/Nav"

const ConditionsGenerales = () => {
  const colors = { primary: "#ffaa00", secondary: "#8A8A89" };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const sections = [
    {
      title: "1. Objet",
      icon: <FileText size={20} className="text-[#ffaa00]" />,
      content: "Les présentes conditions générales de vente régissent les relations contractuelles entre Electro Titan et son client, les deux parties les acceptant sans réserve."
    },
    {
      title: "2. Produits & Prix",
      icon: <ShieldCheck size={20} className="text-[#ffaa00]" />,
      content: "Tous nos produits sont garantis authentiques. Les prix sont indiqués en Dirhams (MAD) et sont susceptibles d'être modifiés sans préavis selon le marché."
    },
    {
      title: "3. Livraison & Délais",
      icon: <Scale size={20} className="text-[#ffaa00]" />,
      content: "Nous livrons partout au Maroc. Les délais varient entre 24h et 72h selon la ville de destination."
    }
  ];

  return (
    <>
      {/* --- SEO START --- */}
      <Helmet>
        <title>Conditions Générales de Vente | Electro Titan Maroc</title>
        <meta key="description" name="description" content="Consultez les conditions générales de vente d'Electro Titan. Informations sur les garanties produits, les prix en MAD et les délais de livraison au Maroc." />
        {/* We tell bots to index it (for trust) but it's not a priority for search ranking */}
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {/* --- SEO END --- */}

      <Header />
      <Nav />

      <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header - Consistent with Contact Page */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tighter">
              Conditions <span style={{ color: colors.primary }}>Générales</span>
            </h1>
            <div className="h-2 w-24 mt-2" style={{ backgroundColor: colors.primary }}></div>
            <p className="text-[#8A8A89] font-bold mt-6 uppercase text-xs tracking-[0.2em]">
              Dernière mise à jour : Février 2026
            </p>
          </motion.div>

          {/* Content Body */}
          <div className="space-y-12">
            {sections.map((section, index) => (
              <motion.section 
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="relative pl-8 border-l-2 border-gray-100"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2 bg-gray-50 rounded-xl">
                    {section.icon}
                  </div>
                  {/* Semantic Heading 2 for structure */}
                  <h2 className="text-lg font-black uppercase tracking-widest">{section.title}</h2>
                </div>
                <p className="text-gray-600 leading-relaxed font-medium">
                  {section.content}
                </p>
              </motion.section>
            ))}

            {/* Important Notice Box */}
            <div className="p-8 bg-gray-50 rounded-[2.5rem] border border-gray-100 mt-16">
              <div className="flex items-start gap-4">
                <AlertCircle style={{ color: colors.primary }} className="shrink-0" />
                <div>
                  <h3 className="font-black uppercase text-sm tracking-widest mb-2">Note Importante</h3>
                  <p className="text-sm text-[#8A8A89] font-bold leading-relaxed">
                    L'utilisation de notre site web implique l'acceptation intégrale de ces conditions. Electro Titan se réserve le droit de modifier ces termes à tout moment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer/>
    </>
  );
};

export default ConditionsGenerales;